import { createSuccessTracker } from './analytics-core.mjs'
/**
 * Analytics 工具函数
 * 用于统一管理 Google Analytics 和 Microsoft Clarity 事件上报
 */

declare global {
  interface Window {
    gtag?: (...args: any[]) => void
    clarity?: (...args: any[]) => void
  }
}

const AI_REFERRERS: Array<[domain: string, source: string]> = [
  ['chatgpt.com', 'chatgpt'],
  ['chat.openai.com', 'chatgpt'],
  ['perplexity.ai', 'perplexity'],
  ['claude.ai', 'claude'],
  ['gemini.google.com', 'gemini'],
  ['copilot.microsoft.com', 'copilot'],
  ['poe.com', 'poe'],
  ['you.com', 'you'],
  ['phind.com', 'phind'],
  ['deepseek.com', 'deepseek'],
  ['grok.com', 'grok'],
  ['ai-bot.cn', 'ai-bot'],
]

export function getAIReferrerSource(referrer: string): string | null {
  if (!referrer) return null
  try {
    const hostname = new URL(referrer).hostname.toLowerCase()
    return AI_REFERRERS.find(([domain]) => hostname === domain || hostname.endsWith(`.${domain}`))?.[1] || null
  } catch {
    return null
  }
}

/** All callers share the consent, ready and parameter gates. */
export function trackEvent(eventName: string, params?: Record<string, any>) {
  if (typeof window !== 'undefined') window.musicmintAnalytics?.track(eventName, params);
}
export const trackGAEvent = trackEvent;
// Session recording remains disabled until its masking/URL policy is separately verified.
export function trackClarityEvent(_eventName: string, _metadata?: Record<string, any>) {}

declare global {
  interface Window {
    musicmintAnalytics?: { track: (name: string, params?: Record<string, any>) => boolean; setConsent: (value: string) => void; granted: () => boolean };
  }
}

const successes = () => createSuccessTracker({storage: () => sessionStorage, emit: trackEvent});
export function rememberAnalyticsGeneration(owner: string, task: string, source: string) {
  if (typeof window !== 'undefined' && window.musicmintAnalytics?.granted()) successes().remember(owner, task, source);
}
export function trackAnalyticsGeneration(owner: string, task: any) {
  if (typeof window !== 'undefined' && window.musicmintAnalytics?.granted()) successes().complete(owner, task);
}
export function trackConfirmedSignUp(owner: string, sessionId: string, signup: any) {
  if (typeof window !== 'undefined' && window.musicmintAnalytics?.granted()) successes().signup(owner, sessionId, signup);
}
